import 'twin.macro';
import 'styled-components/macro';

import { HTMLAttributes, forwardRef } from 'react';

import { ReactComponent as BarIcon } from './assets/Bar.svg';
import { ReactComponent as CheckIcon } from './assets/Check.svg';

export interface CheckboxIndicatorProps extends HTMLAttributes<HTMLSpanElement> {
  isIndeterminate?: boolean;
}

export const CheckboxIndicator = forwardRef<HTMLSpanElement, CheckboxIndicatorProps>(
  ({ isIndeterminate, ...props }, forwardedRef) => (
    <span
      {...props}
      ref={forwardedRef}
      tw="
        w-full
        h-full

        flex
        items-center
        justify-center

        bg-secondary
        text-white

        transition-all
        duration-fast

        opacity-0
        data-[state=checked]:opacity-100
        data-[state=indeterminate]:opacity-100
        data-[disabled]:data-[state=checked]:bg-gray-50
        data-[disabled]:data-[state=indeterminate]:bg-gray-50"
    >
      {isIndeterminate ? <BarIcon tw="w-[12px]" /> : <CheckIcon tw="w-[12px]" />}
    </span>
  ),
);
